module.exports = __webpack_public_path__ + "static/img/delivery.67d3fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/delivery.png
// module id = 182
// module chunks = 2